import React from 'react';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './SkeletonComponent.css';

const skeletonTemplate = require('./SkeletonComponent.json');

const SkeletonComponent = (props) => {
  const properties =
    skeletonTemplate.skeletonScreenComponents[props.componentName].properties;
  return (
    <div data-testid="loading-skelton">
      <SkeletonTheme>
        {properties.map((item, key) => (
          <Skeleton key={key} animation="wave" {...item} />
        ))}
      </SkeletonTheme>
    </div>
  );
};

export default SkeletonComponent;
